import {Component} from 'react';
import axios from "axios"
import Nav from "../Nav";
import Swal from "sweetalert2";
import myconfig from "../../myconfig";
import * as XLSX from "xlsx";
import Select from 'react-select'
import makeAnimated from 'react-select/animated';

import { Modal,Button } from 'react-bootstrap';
let source = axios.CancelToken.source();

class Screen_1 extends Component {
    constructor() {
        super();
        var date = new Date();
        this.state = {
            objs: [],
            objsl: false,

            objs2: [],
            objsl2: false,

            id: "-1",
            iscreate: false,

            vehicles: [],
            vehicle_selected: null,

            stlocs: [],
            stloc_selected: null,
            edlocs: [],
            edloc_selected: null,

            head_1: [],
            head_1_selected: null,

            head_2: [],
            head_2_selected: null,

            head_3: [],
            head_3_selected: null,
            st: date.toISOString().split('T')[0] + " 00:00:00",

            cushow:false,
            status:[],
            name:'',

            cushow2:false,
            movs:[],
        }
    }

    componentDidMount() {
        this.fetchdata()
        this.fetchdata_2()
        setInterval(() => {
            this.fetchdata()
            this.fetchdata_2()
        }, 180000)

    }

    fetchdata = () => {
        let baseurl = myconfig.get_screen_1;
        let redirecttologin = myconfig.redirecttologin;
        axios.post(baseurl, {
            sid: window.localStorage.getItem("ntfms_sid"),
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                window.localStorage.setItem("ntfms_sid", null);
                window.localStorage.setItem("ntfms_username", null);
                window.localStorage.setItem("ntfms_name", null);
                var win = window.open(redirecttologin, "_self");
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    objs: res.data,
                    objsl: true,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }
    fetchdata_2 = () => {
        let baseurl = myconfig.get_mov_screen_1;
        let redirecttologin = myconfig.redirecttologin;
        axios.post(baseurl, {
            sid: window.localStorage.getItem("ntfms_sid"),
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                window.localStorage.setItem("ntfms_sid", null);
                window.localStorage.setItem("ntfms_username", null);
                window.localStorage.setItem("ntfms_name", null);
                var win = window.open(redirecttologin, "_self");
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    objs2: res.data,
                    objsl2: true,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }

    componentWillUnmount() {
        try {
            if (source) {
                source.cancel("Landing Component got unmounted");
            }
        } catch (e) {

        }
    }

    inputmgt = (event) => {
        event.preventDefault();
        var name = event.target.name;
        var value = event.target.value;
        this.setState({
            [name]: value,
        })
    }
    orgs = () => {
        let retdata = null;
        if (this.state.objsl) {
            let count = 0;
            let orgs = this.state.objs.orgs.map(value => {
                count = count + 1
                if(value.type=="WAITING_FOR_ORDER")
                    return (<>
                        <div className="row" style={{backgroundColor:"#000000FF",color:"#FFFFFFFF"}}>
                            <div className="col-sm-1"><p>{count}</p></div>
                            <div className="col-sm-2"><p className="text-sm text-bold">{value.plate_no}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.start_at}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.end_at}</p></div>
                            <div className="col-sm-4"><p className="text-sm">{value.avlloc}</p></div>
                            <div className="col-sm-2"><p className="text-sm">{value.type}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.km}</p></div>

                        </div>
                    </>)
                else if(value.type=="HEADING_TO_STATION")
                    return (<>
                        <div className="row" style={{backgroundColor:"#5F4B8BFF",color:"#E69A8DFF"}}>
                            <div className="col-sm-1"><p>{count}</p></div>
                            <div className="col-sm-2"><p className="text-sm text-bold">{value.plate_no}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.start_at}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.end_at}</p></div>
                            <div className="col-sm-4"><p className="text-sm">{value.avlloc}</p></div>
                            <div className="col-sm-2"><p className="text-sm">{value.type}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.km}</p></div>

                        </div>
                    </>)
                else if(value.type=="ALLOCATED_UNDER_DISPATCH")
                    return (<>
                        <div className="row" style={{backgroundColor:"#949398FF",color:"#F4DF4EFF"}}>
                            <div className="col-sm-1"><p>{count}</p></div>
                            <div className="col-sm-2"><p className="text-sm text-bold">{value.plate_no}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.start_at}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.end_at}</p></div>
                            <div className="col-sm-4"><p className="text-sm">{value.avlloc}</p></div>
                            <div className="col-sm-2"><p className="text-sm">{value.type}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.km}</p></div>

                        </div>
                    </>)
                else if(value.type=="IN_TRANSIT_TO_LOAD_POINT")
                    return (<>
                        <div className="row" style={{backgroundColor:"#89ABE3FF",color:"#FCF6F5FF"}}>
                            <div className="col-sm-1"><p>{count}</p></div>
                            <div className="col-sm-2"><p className="text-sm text-bold">{value.plate_no}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.start_at}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.end_at}</p></div>
                            <div className="col-sm-4"><p className="text-sm">{value.avlloc}</p></div>
                            <div className="col-sm-2"><p className="text-sm">{value.type}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.km}</p></div>

                        </div>
                    </>)
                else if(value.type=="WAITING_TO_LOAD")
                    return (<>
                        <div className="row" style={{backgroundColor:"#00203FFF",color:"#ADEFD1FF"}}>
                            <div className="col-sm-1"><p>{count}</p></div>
                            <div className="col-sm-2"><p className="text-sm text-bold">{value.plate_no}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.start_at}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.end_at}</p></div>
                            <div className="col-sm-4"><p className="text-sm">{value.avlloc}</p></div>
                            <div className="col-sm-2"><p className="text-sm">{value.type}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.km}</p></div>

                        </div>
                    </>)
                else if(value.type=="WAITING_TO_TRANSIT")
                    return (<>
                        <div className="row" style={{backgroundColor:"#606060FF",color:"#D6ED17FF"}}>
                            <div className="col-sm-1"><p>{count}</p></div>
                            <div className="col-sm-2"><p className="text-sm text-bold">{value.plate_no}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.start_at}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.end_at}</p></div>
                            <div className="col-sm-4"><p className="text-sm">{value.avlloc}</p></div>
                            <div className="col-sm-2"><p className="text-sm">{value.type}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.km}</p></div>

                        </div>
                    </>)
                else if(value.type=="IN_TRANSIT_TO_OFFLOAD_POINT")
                    return (<>
                        <div className="row" style={{backgroundColor:"#00539CFF",color:"#EEA47FFF"}}>
                            <div className="col-sm-1"><p>{count}</p></div>
                            <div className="col-sm-2"><p className="text-sm text-bold">{value.plate_no}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.start_at}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.end_at}</p></div>
                            <div className="col-sm-4"><p className="text-sm">{value.avlloc}</p></div>
                            <div className="col-sm-2"><p className="text-sm">{value.type}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.km}</p></div>

                        </div>
                    </>)
                else
                    return (<>
                        <div className="row" style={{backgroundColor:"#101820FF",color:"#FEE715FF"}}>
                            <div className="col-sm-1"><p>{count}</p></div>
                            <div className="col-sm-2"><p className="text-sm text-bold">{value.plate_no}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.start_at}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.end_at}</p></div>
                            <div className="col-sm-4"><p className="text-sm">{value.avlloc}</p></div>
                            <div className="col-sm-2"><p className="text-sm">{value.type}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.km}</p></div>

                        </div>
                    </>)
            })
            return (<>
                <div className="card card-primary" style={{height: "100%"}}>
                    <div className="card-header">
                        <h3 className="card-title">Origin</h3>
                    </div>
                    <div className="card-header m-1 p-1">
                        <div className="row">
                            <div className="col-sm-1  m-0 px-1"><p className="text-sm text-bold">#</p></div>
                            <div className="col-sm-2  m-0 px-1"><p className="text-sm text-bold">Truck</p></div>
                            <div className="col-sm-1 m-0 px-1"><p className="text-sm text-bold">Start at</p></div>
                            <div className="col-sm-1  m-0 px-1"><p className="text-sm text-bold">End at</p></div>
                            <div className="col-sm-4  m-0 px-1"><p className="text-sm text-bold">Location</p></div>
                            <div className="col-sm-2  m-0 px-1"><p className="text-sm text-bold">Status</p></div>
                            <div className="col-sm-1  m-0 px-1"><p className="text-sm text-bold">Millage</p></div>
                        </div>
                    </div>
                    <div className="card-body px-1 table-responsive">
                        {orgs}
                    </div>
                    {/* /.card-body */}
                </div>
            </>)
        }
        return <>{retdata}</>
    }
    dess = () => {
        let retdata = null;
        if (this.state.objsl) {
            let count = 0;
            let dess = this.state.objs.dess.map(value => {
                count = count + 1
                if(value.type=="WAITING_FOR_ORDER")
                    return (<>
                        <div className="row" style={{backgroundColor:"#000000FF",color:"#FFFFFFFF"}}>
                            <div className="col-sm-1"><p>{count}</p></div>
                            <div className="col-sm-2"><p className="text-sm text-bold">{value.plate_no}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.start_at}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.end_at}</p></div>
                            <div className="col-sm-4"><p className="text-sm">{value.avlloc}</p></div>
                            <div className="col-sm-2"><p className="text-sm">{value.type}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.km}</p></div>

                        </div>
                    </>)
                else if(value.type=="HEADING_TO_STATION")
                    return (<>
                        <div className="row" style={{backgroundColor:"#5F4B8BFF",color:"#E69A8DFF"}}>
                            <div className="col-sm-1"><p>{count}</p></div>
                            <div className="col-sm-2"><p className="text-sm text-bold">{value.plate_no}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.start_at}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.end_at}</p></div>
                            <div className="col-sm-4"><p className="text-sm">{value.avlloc}</p></div>
                            <div className="col-sm-2"><p className="text-sm">{value.type}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.km}</p></div>

                        </div>
                    </>)
                else if(value.type=="ALLOCATED_UNDER_DISPATCH")
                    return (<>
                        <div className="row" style={{backgroundColor:"#949398FF",color:"#F4DF4EFF"}}>
                            <div className="col-sm-1"><p>{count}</p></div>
                            <div className="col-sm-2"><p className="text-sm text-bold">{value.plate_no}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.start_at}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.end_at}</p></div>
                            <div className="col-sm-4"><p className="text-sm">{value.avlloc}</p></div>
                            <div className="col-sm-2"><p className="text-sm">{value.type}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.km}</p></div>

                        </div>
                    </>)
                else if(value.type=="IN_TRANSIT_TO_LOAD_POINT")
                    return (<>
                        <div className="row" style={{backgroundColor:"#89ABE3FF",color:"#FCF6F5FF"}}>
                            <div className="col-sm-1"><p>{count}</p></div>
                            <div className="col-sm-2"><p className="text-sm text-bold">{value.plate_no}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.start_at}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.end_at}</p></div>
                            <div className="col-sm-4"><p className="text-sm">{value.avlloc}</p></div>
                            <div className="col-sm-2"><p className="text-sm">{value.type}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.km}</p></div>

                        </div>
                    </>)
                else if(value.type=="WAITING_TO_LOAD")
                    return (<>
                        <div className="row" style={{backgroundColor:"#00203FFF",color:"#ADEFD1FF"}}>
                            <div className="col-sm-1"><p>{count}</p></div>
                            <div className="col-sm-2"><p className="text-sm text-bold">{value.plate_no}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.start_at}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.end_at}</p></div>
                            <div className="col-sm-4"><p className="text-sm">{value.avlloc}</p></div>
                            <div className="col-sm-2"><p className="text-sm">{value.type}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.km}</p></div>

                        </div>
                    </>)
                else if(value.type=="WAITING_TO_TRANSIT")
                    return (<>
                        <div className="row" style={{backgroundColor:"#606060FF",color:"#D6ED17FF"}}>
                            <div className="col-sm-1"><p>{count}</p></div>
                            <div className="col-sm-2"><p className="text-sm text-bold">{value.plate_no}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.start_at}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.end_at}</p></div>
                            <div className="col-sm-4"><p className="text-sm">{value.avlloc}</p></div>
                            <div className="col-sm-2"><p className="text-sm">{value.type}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.km}</p></div>

                        </div>
                    </>)
                else if(value.type=="IN_TRANSIT_TO_OFFLOAD_POINT")
                    return (<>
                        <div className="row" style={{backgroundColor:"#00539CFF",color:"#EEA47FFF"}}>
                            <div className="col-sm-1"><p>{count}</p></div>
                            <div className="col-sm-2"><p className="text-sm text-bold">{value.plate_no}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.start_at}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.end_at}</p></div>
                            <div className="col-sm-4"><p className="text-sm">{value.avlloc}</p></div>
                            <div className="col-sm-2"><p className="text-sm">{value.type}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.km}</p></div>

                        </div>
                    </>)
                else
                    return (<>
                        <div className="row" style={{backgroundColor:"#101820FF",color:"#FEE715FF"}}>
                            <div className="col-sm-1"><p>{count}</p></div>
                            <div className="col-sm-2"><p className="text-sm text-bold">{value.plate_no}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.start_at}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.end_at}</p></div>
                            <div className="col-sm-4"><p className="text-sm">{value.avlloc}</p></div>
                            <div className="col-sm-2"><p className="text-sm">{value.type}</p></div>
                            <div className="col-sm-1"><p className="text-sm">{value.km}</p></div>

                        </div>
                    </>)
            })
            return (<>
                <div className="card card-cyan" style={{height: "100%"}}>
                    <div className="card-header">
                        <h3 className="card-title">Destination</h3>
                    </div>
                    <div className="card-header m-1 p-1">
                        <div className="row">
                            <div className="col-sm-1  m-0 px-1"><p className="text-sm text-bold">#</p></div>
                            <div className="col-sm-2  m-0 px-1"><p className="text-sm text-bold">Truck</p></div>
                            <div className="col-sm-1 m-0 px-1"><p className="text-sm text-bold">Start at</p></div>
                            <div className="col-sm-1  m-0 px-1"><p className="text-sm text-bold">End at</p></div>
                            <div className="col-sm-4  m-0 px-1"><p className="text-sm text-bold">Location</p></div>
                            <div className="col-sm-2  m-0 px-1"><p className="text-sm text-bold">Status</p></div>
                            <div className="col-sm-1  m-0 px-1"><p className="text-sm text-bold">Millage</p></div>
                        </div>
                    </div>
                    <div className="card-body px-1 table-responsive">
                        {dess}
                    </div>
                    {/* /.card-body */}
                </div>
            </>)
        }
        return <>{retdata}</>
    }
    summury = () => {
        let retdata = null;
        if (this.state.objsl) {
            let dd_wfo=this.state.objs.diredawa.filter(v=>{
                if(v.type=="WAITING_FOR_ORDER")
                    return v;
            }).length;
            let dd_hs=this.state.objs.diredawa.filter(v=>{
                if(v.type=="HEADING_TO_STATION")
                    return v;
            }).length;
            let dd_aud=this.state.objs.diredawa.filter(v=>{
                if(v.type=="ALLOCATED_UNDER_DISPATCH")
                    return v;
            }).length;
            let dd_ittlp=this.state.objs.diredawa.filter(v=>{
                if(v.type=="IN_TRANSIT_TO_LOAD_POINT")
                    return v;
            }).length;
            let dd_wtl=this.state.objs.diredawa.filter(v=>{
                if(v.type=="WAITING_TO_LOAD")
                    return v;
            }).length;
            let dd_wtt=this.state.objs.diredawa.filter(v=>{
                if(v.type=="WAITING_TO_TRANSIT")
                    return v;
            }).length;
            let dd_ittop=this.state.objs.diredawa.filter(v=>{
                if(v.type=="IN_TRANSIT_TO_OFFLOAD_POINT")
                    return v;
            }).length;
            let dd_wto=this.state.objs.diredawa.filter(v=>{
                if(v.type=="WAITING_TO_OFFLOAD")
                    return v;
            }).length;

            let dw_wfo=this.state.objs.dawro.filter(v=>{
                if(v.type=="WAITING_FOR_ORDER")
                    return v;
            }).length;
            let dw_hs=this.state.objs.dawro.filter(v=>{
                if(v.type=="HEADING_TO_STATION")
                    return v;
            }).length;
            let dw_aud=this.state.objs.dawro.filter(v=>{
                if(v.type=="ALLOCATED_UNDER_DISPATCH")
                    return v;
            }).length;
            let dw_ittlp=this.state.objs.dawro.filter(v=>{
                if(v.type=="IN_TRANSIT_TO_LOAD_POINT")
                    return v;
            }).length;
            let dw_wtl=this.state.objs.dawro.filter(v=>{
                if(v.type=="WAITING_TO_LOAD")
                    return v;
            }).length;
            let dw_wtt=this.state.objs.dawro.filter(v=>{
                if(v.type=="WAITING_TO_TRANSIT")
                    return v;
            }).length;
            let dw_ittop=this.state.objs.dawro.filter(v=>{
                if(v.type=="IN_TRANSIT_TO_OFFLOAD_POINT")
                    return v;
            }).length;
            let dw_wto=this.state.objs.dawro.filter(v=>{
                if(v.type=="WAITING_TO_OFFLOAD")
                    return v;
            }).length;

            let kk_wfo=this.state.objs.koka.filter(v=>{
                if(v.type=="WAITING_FOR_ORDER")
                    return v;
            }).length;
            let kk_hs=this.state.objs.koka.filter(v=>{
                if(v.type=="HEADING_TO_STATION")
                    return v;
            }).length;
            let kk_aud=this.state.objs.koka.filter(v=>{
                if(v.type=="ALLOCATED_UNDER_DISPATCH")
                    return v;
            }).length;
            let kk_ittlp=this.state.objs.koka.filter(v=>{
                if(v.type=="IN_TRANSIT_TO_LOAD_POINT")
                    return v;
            }).length;
            let kk_wtl=this.state.objs.koka.filter(v=>{
                if(v.type=="WAITING_TO_LOAD")
                    return v;
            }).length;
            let kk_wtt=this.state.objs.koka.filter(v=>{
                if(v.type=="WAITING_TO_TRANSIT")
                    return v;
            }).length;
            let kk_ittop=this.state.objs.koka.filter(v=>{
                if(v.type=="IN_TRANSIT_TO_OFFLOAD_POINT")
                    return v;
            }).length;

            let kk_wto=this.state.objs.koka.filter(v=>{
                if(v.type=="WAITING_TO_OFFLOAD")
                    return v;
            }).length;

            let ot_wfo=this.state.objs.other.filter(v=>{
                if(v.type=="WAITING_FOR_ORDER")
                    return v;
            }).length;
            let ot_hs=this.state.objs.other.filter(v=>{
                if(v.type=="HEADING_TO_STATION")
                    return v;
            }).length;
            let ot_aud=this.state.objs.other.filter(v=>{
                if(v.type=="ALLOCATED_UNDER_DISPATCH")
                    return v;
            }).length;
            let ot_ittlp=this.state.objs.other.filter(v=>{
                if(v.type=="IN_TRANSIT_TO_LOAD_POINT")
                    return v;
            }).length;
            let ot_wtl=this.state.objs.other.filter(v=>{
                if(v.type=="WAITING_TO_LOAD")
                    return v;
            }).length;
            let ot_wtt=this.state.objs.other.filter(v=>{
                if(v.type=="WAITING_TO_TRANSIT")
                    return v;
            }).length;
            let ot_ittop=this.state.objs.other.filter(v=>{
                if(v.type=="IN_TRANSIT_TO_OFFLOAD_POINT")
                    return v;
            }).length;
            let ot_wto=this.state.objs.other.filter(v=>{
                if(v.type=="WAITING_TO_OFFLOAD")
                    return v;
            }).length;

            return (<>
                <div className="card card-primary  px-1 table-responsive" style={{height: "100%"}}>
                    <div className="col-12">
                        <div className="card card-widget widget-user-2 shadow-sm">
                            <div className="widget-user-header bg-warning">
                                <h3 className>Dire Dawa</h3>
                            </div>
                            <div className="card-footer p-0">
                                <ul className="nav flex-column">
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Dire Dawa","WAITING_FOR_ORDER")} href="" className="nav-link">
                                            WAITING_FOR_ORDER <span className="float-right badge bg-success">{dd_wfo}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Dire Dawa","HEADING_TO_STATION")} href="" className="nav-link">
                                            HEADING_TO_STATION <span className="float-right badge bg-info">{dd_hs}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Dire Dawa","ALLOCATED_UNDER_DISPATCH")} href="" className="nav-link">ALLOCATED_UNDER_DISPATCH<span
                                            className="float-right badge bg-primary">{dd_aud}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Dire Dawa","IN_TRANSIT_TO_LOAD_POINT")} href="" className="nav-link">
                                            IN_TRANSIT_TO_LOAD_POINT <span className="float-right badge bg-info">{dd_ittlp}</span>
                                        </a>
                                    </li>

                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Dire Dawa","WAITING_TO_LOAD")}  href="" className="nav-link">
                                            WAITING_TO_LOAD <span className="float-right badge bg-danger">{dd_wtl}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Dire Dawa","WAITING_TO_TRANSIT")}  href="" className="nav-link">
                                            WAITING_TO_TRANSIT <span className="float-right badge bg-success">{dd_wtt}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Dire Dawa","IN_TRANSIT_TO_OFFLOAD_POINT")} href=""  className="nav-link">
                                            IN_TRANSIT_TO_OFFLOAD_POINT <span className="float-right badge bg-info">{dd_ittop}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Dire Dawa","WAITING_TO_OFFLOAD")}  href="" className="nav-link">WAITING_TO_OFFLOAD<span
                                            className="float-right badge bg-primary">{dd_wto}</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="card card-widget widget-user-2 shadow-sm">
                            <div className="widget-user-header bg-primary">
                                <h3 className>Dawro</h3>
                            </div>
                            <div className="card-footer p-0">
                                <ul className="nav flex-column">
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Dawro","WAITING_FOR_ORDER")} href=""  className="nav-link">
                                            WAITING_FOR_ORDER <span className="float-right badge bg-success">{dw_wfo}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Dawro","HEADING_TO_STATION")}  href="" className="nav-link">
                                            HEADING_TO_STATION <span className="float-right badge bg-info">{dw_hs}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Dawro","ALLOCATED_UNDER_DISPATCH")}  href="" className="nav-link">ALLOCATED_UNDER_DISPATCH<span
                                            className="float-right badge bg-primary">{dw_aud}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Dawro","IN_TRANSIT_TO_LOAD_POINT")}  href="" className="nav-link">
                                            IN_TRANSIT_TO_LOAD_POINT <span className="float-right badge bg-info">{dw_ittlp}</span>
                                        </a>
                                    </li>

                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Dawro","WAITING_TO_LOAD")}  href="" className="nav-link">
                                            WAITING_TO_LOAD <span className="float-right badge bg-danger">{dw_wtl}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Dawro","WAITING_TO_TRANSIT")}  href="" className="nav-link">
                                            WAITING_TO_TRANSIT <span className="float-right badge bg-success">{dw_wtt}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Dawro","IN_TRANSIT_TO_OFFLOAD_POINT")} href=""  className="nav-link">
                                            IN_TRANSIT_TO_OFFLOAD_POINT <span className="float-right badge bg-info">{dw_ittop}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Dawro","WAITING_TO_OFFLOAD")}  href="" className="nav-link">WAITING_TO_OFFLOAD<span
                                            className="float-right badge bg-primary">{dw_wto}</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="card card-widget widget-user-2 shadow-sm">
                            <div className="widget-user-header bg-fuchsia">
                                <h3 className>Koka</h3>
                            </div>
                            <div className="card-footer p-0">
                                <ul className="nav flex-column">
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Koka","WAITING_FOR_ORDER")}  href="" className="nav-link">
                                            WAITING_FOR_ORDER <span className="float-right badge bg-success">{kk_wfo}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Koka","HEADING_TO_STATION")}  href="" className="nav-link">
                                            HEADING_TO_STATION <span className="float-right badge bg-info">{kk_hs}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Koka","ALLOCATED_UNDER_DISPATCH")}  href="" className="nav-link">ALLOCATED_UNDER_DISPATCH<span
                                            className="float-right badge bg-primary">{kk_aud}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Koka","IN_TRANSIT_TO_LOAD_POINT")} href=""  className="nav-link">
                                            IN_TRANSIT_TO_LOAD_POINT <span className="float-right badge bg-info">{kk_ittlp}</span>
                                        </a>
                                    </li>

                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Koka","WAITING_TO_LOAD")}  href="" className="nav-link">
                                            WAITING_TO_LOAD <span className="float-right badge bg-danger">{kk_wtl}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Koka","WAITING_TO_TRANSIT")}  href="" className="nav-link">
                                            WAITING_TO_TRANSIT <span className="float-right badge bg-success">{kk_wtt}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Koka","IN_TRANSIT_TO_OFFLOAD_POINT")}  href="" className="nav-link">
                                            IN_TRANSIT_TO_OFFLOAD_POINT <span className="float-right badge bg-info">{kk_ittop}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Koka","WAITING_TO_OFFLOAD")}  href="" className="nav-link">WAITING_TO_OFFLOAD<span
                                            className="float-right badge bg-primary">{kk_wto}</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="card card-widget widget-user-2 shadow-sm">
                            <div className="widget-user-header bg-gradient-green">
                                <h3 className>Other</h3>
                            </div>
                            <div className="card-footer p-0">
                                <ul className="nav flex-column">
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Other","WAITING_FOR_ORDER")} href=""  className="nav-link">
                                            WAITING_FOR_ORDER <span className="float-right badge bg-success">{ot_wfo}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Other","HEADING_TO_STATION")} href=""  className="nav-link">
                                            HEADING_TO_STATION <span className="float-right badge bg-info">{ot_hs}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Other","ALLOCATED_UNDER_DISPATCH")} href=""  className="nav-link">ALLOCATED_UNDER_DISPATCH<span
                                            className="float-right badge bg-primary">{ot_aud}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Other","IN_TRANSIT_TO_LOAD_POINT")} href="#" className="nav-link">
                                            IN_TRANSIT_TO_LOAD_POINT <span className="float-right badge bg-info">{ot_ittlp}</span>
                                        </a>
                                    </li>

                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Other","WAITING_TO_LOAD")} href="#" className="nav-link">
                                            WAITING_TO_LOAD <span className="float-right badge bg-danger">{ot_wtl}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Other","WAITING_TO_TRANSIT")} href="#" className="nav-link">
                                            WAITING_TO_TRANSIT <span className="float-right badge bg-success">{ot_wtt}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Other","IN_TRANSIT_TO_OFFLOAD_POINT")} href="#"  className="nav-link">
                                            IN_TRANSIT_TO_OFFLOAD_POINT <span className="float-right badge bg-info">{ot_ittop}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Other","WAITING_TO_OFFLOAD")} href="#"  className="nav-link">WAITING_TO_OFFLOAD<span
                                            className="float-right badge bg-primary">{ot_wto}</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </>)
        }
        return <>
            {retdata}
        </>
    }
    vio = () => {
        let retdata = null;
        if (this.state.objsl2) {
            let count = 0;
            let speeds = this.state.objs2.speeds.map(value => {
                count = count + 1
                return (<>
                    <div className="row">
                        <div className="col-sm-1"><p>{count}</p></div>
                        <div className="col-sm-2"><p className="text-sm text-bold">{value.plate_no}</p></div>
                        <div className="col-sm-2"><p className="text-sm">{value.mspe}</p></div>
                        <div className="col-sm-2"><p className="text-sm">{value.dur}</p></div>
                        <div className="col-sm-2"><p className="text-sm">{value.time}</p></div>
                        <div className="col-sm-3"><p className="text-sm">{value.loc}</p></div>
                    </div>
                </>)
            })
            let sum = this.state.objs2.sum.map(value => {
                count = count + 1
                return (<>
                    <div className="row">
                        <div className="col-sm-2"><p className="text-sm text-bold"><a href="#" onClick={(event => this.showcu2(event,value.veh_id))}>More</a></p></div>
                        <div className="col-sm-4"><p className="text-sm text-bold">{value.plate_no}</p></div>
                        <div className="col-sm-2"><p className="text-sm">{value.startat}</p></div>
                        <div className="col-sm-2"><p className="text-sm">{value.endat}</p></div>
                        <div className="col-sm-2"><p className="text-sm">{value.dur}</p></div>
                    </div>
                </>)
            })
            let spe = <>
                <div className="card card-warning" style={{height: "100%"}}>
                    <div className="card-header">
                        <h3 className="card-title">Speeding</h3>
                    </div>
                    <div className="card-header m-1 p-1">
                        <div className="row">
                            <div className="col-sm-1  m-0 px-1"><p className="text-sm text-bold">#</p></div>
                            <div className="col-sm-2  m-0 px-1"><p className="text-sm text-bold">Truck</p></div>
                            <div className="col-sm-2 m-0 px-1"><p className="text-sm text-bold">Max Speed</p></div>
                            <div className="col-sm-2  m-0 px-1"><p className="text-sm text-bold">Duration</p></div>
                            <div className="col-sm-2  m-0 px-1"><p className="text-sm text-bold">Time</p></div>
                            <div className="col-sm-3  m-0 px-1"><p className="text-sm text-bold">Location</p></div>
                        </div>
                    </div>
                    <div className="card-body px-1 table-responsive">
                        {speeds}
                    </div>
                    {/* /.card-body */}
                </div>
            </>
            let stop = <>
                <div className="card card-fuchsia" style={{height: "100%"}}>
                    <div className="card-header">
                        <h3 className="card-title">Stoppage</h3>
                    </div>
                    <div className="card-header m-1 p-1">
                        <div className="row">
                            <div className="col-sm-2  m-0 px-1"><p className="text-sm text-bold">Action</p></div>
                            <div className="col-sm-4  m-0 px-1"><p className="text-sm text-bold">Truck</p></div>
                            <div className="col-sm-2  m-0 px-1"><p className="text-sm text-bold">Start At</p></div>
                            <div className="col-sm-2  m-0 px-1"><p className="text-sm text-bold">End At</p></div>
                            <div className="col-sm-2 m-0 px-1"><p className="text-sm text-bold">Stoppage</p></div>
                        </div>
                    </div>
                    <div className="card-body px-1 table-responsive">
                        {sum}
                    </div>
                    {/* /.card-body */}
                </div>
            </>
            return <>
                <div className="card card-danger" style={{height: "100%"}}>
                    <div className="card-header">
                        <h3 className="card-title">Violation</h3>
                    </div>
                    <div className="card-body px-1 table-responsive">
                        {spe}
                        {stop}
                    </div>
                </div>
            </>
        }
    }

    showcu = (event,name,type) => {
        event.preventDefault()
        if (this.state.objsl) {
            let status = [];
            if (name == "Dire Dawa")
                status = this.state.objs.diredawa.filter(value => {
                    if (value.type == type)
                        return value;
                })
            else if (name == "Dawro")
                status = this.state.objs.dawro.filter(value => {
                    if (value.type == type)
                        return value;
                })
            else if (name == "Koka")
                status = this.state.objs.koka.filter(value => {
                    if (value.type == type)
                        return value;
                })
            else if (name == "Other")
                status = this.state.objs.other.filter(value => {
                    if (value.type == type)
                        return value;
                })
            this.setState({
                cushow: true,
                status: status,
                name: name,
            })
        }
    }
    hidecu = () => {
        this.setState({
            cushow: false,
        })
    }
    modalcu = () => {
        let count=0;
        let tabledata=this.state.status.map(value => {
            count=count+1;
            return (
                <tr>
                    <td>{count}</td>
                    <td>{value.plate_no}</td>
                    <td>{value.start_at}</td>
                    <td>{value.end_at}</td>
                    <td>{value.avlloc}</td>
                    <td>{value.avltime}</td>
                    <td>{value.km}</td>
                    <td>{value.type}</td>
                </tr>
            )
        });

        return (<Modal
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={this.state.cushow}
                onHide={this.hidecu}>
                <Modal.Header><h4>{this.state.name}</h4></Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card card-primary">
                                <div className="card-header">
                                    <h3 className="card-title">Data's</h3>
                                </div>
                                <div className="card-body table-responsive p-0" style={{height: '500px'}}>
                                    <table className="table table-head-fixed text-nowrap">
                                        <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Plate #</th>
                                            <th>Orgin</th>
                                            <th>Destination</th>
                                            <th>Location</th>
                                            <th>Update Time</th>
                                            <th>Millage</th>
                                            <th>Status</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {tabledata}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }


    showcu2 = (event,id) => {
        event.preventDefault()

        if (this.state.objsl2) {
            let movs = this.state.objs2.detmov.filter(value => {
                if (value.veh_id == id)
                    return value;
            })
            this.setState({
                cushow2: true,
                movs:movs,
            })
        }
    }
    hidecu2 = () => {
        this.setState({
            cushow2: false,
        })
    }
    modalcu2 = () => {
        let count=0;
        let tabledata=this.state.movs.map(value => {
            count=count+1;
            return (
                <tr>
                    <td>{count}</td>
                    <td>{value.plate_no}</td>
                    <td>{value.dt}</td>
                    <td><p title={value.long_name}>{value.short_name}</p></td>
                    <td>{value.talcon}</td>
                    <td>{value.durcon}</td>
                    <td>{value.type}</td>
                </tr>
            )
        });

        return (<Modal
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={this.state.cushow2}
                onHide={this.hidecu2}>
                <Modal.Header><h4>Movement Report</h4></Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card card-primary">
                                <div className="card-header">
                                    <h3 className="card-title">Data's</h3>
                                </div>
                                <div className="card-body table-responsive p-0" style={{height: '500px'}}>
                                    <table className="table table-head-fixed text-nowrap">
                                        <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Plate #</th>
                                            <th>Time</th>
                                            <th>Location</th>
                                            <th>Time At location</th>
                                            <th>Stoppage</th>
                                            <th>Type</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {tabledata}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
    render() {
        return (
            <>
                <div>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-md-6" style={{height:"50vh"}}>{this.orgs()}</div>
                                <div className="col-md-6" style={{height:"50vh"}}>{this.dess()}</div>
                                <div className="col-md-6" style={{height:"50vh"}}>{this.summury()}</div>
                                <div className="col-md-6" style={{height:"50vh"}}>{this.vio()}</div>
                            </div>
                        </div>
                    </section>
                </div>
                {this.modalcu()}
                {this.modalcu2()}
            </>
        )
    }
}
export default Screen_1;
